import table from '../users/table'

export default{
    table,
}